import YUSPUtil from '../../../core/util/yusp_util';

import { JsEnv } from '../../../core/models/js_env';
import { CategorySJsEnv } from '../models/category_s_js_env';
import { RrRepository } from '../../../core/repositories/rr_repository';
import { getRrAreaData } from '../../../core/models/rr/rr_util';
import { CategorySContainer } from '../views/pc/category_s_container';
import { CategoryS } from '../models/category_s';
import { createRrRequestParam } from '../models/rr/set_rr_request';
import { TypedEvent } from '../../../core/typed_event';
import { AddCartModalAction } from '../../../core/actions/add_cart/modal_action';
import LazyUtil from '../../../core/util/lazy_util';

export class CategorySAction {
  static readonly UPDATE_EVENT = new TypedEvent<CategorySJsEnv>();
  private static state: CategoryS;
  private static rrRepository: RrRepository;

  static init(env: JsEnv) {
    this.state = new CategoryS(env.PAGE);
    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    // カゴモーダルの初期化
    AddCartModalAction.init();

    // おすすめ情報設定がOnかつ、他サプカテではない場合、RR取得処理を実行
    if (model.shouldDisplayRecommend && window['RR'] !== undefined && !model.isSupplier) {

      // thisをCategorySActionにbindしないとcallbackで渡しているのでrenderRr()中のthisがundefinedになってしまう
      window['RR'].jsonCallback = this.renderRr.bind(this);

      this.rrRepository.sendRequestToRrServer(createRrRequestParam(model));
    }
    // YUSP連携 ユーザーID連携、VIEWイベント
    YUSPUtil.register({
      enableUserId: true,
      enableView: true,
    });
    // YUSPエリアを表示
    YUSPUtil.showYUSPArea({
      enableMOrSCategory: true,
    })

    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();
  }

  private static async renderRr() {
    // 外部流入版RRエリアは、外部流入時のみ表示する
    if (this.state.getModel().isFromExternalSite) {
      const rrDataCategorySExternalSite = await getRrAreaData(this.state.getModel().rrAreaProfileCategorySExternalSite);
      this.state.setRrAreaDataCategorySExternalSite(rrDataCategorySExternalSite.items, rrDataCategorySExternalSite.title);
    }

    const rrDataCategorySNormal = await getRrAreaData(this.state.getModel().rrAreaProfileCategorySNormal);
    this.state.setRrAreaDataCategorySNormal(rrDataCategorySNormal.items, rrDataCategorySNormal.title);

    const rrDataCategorySLeftSide = await getRrAreaData(this.state.getModel().rrAreaProfileCategorySLeftSide);
    this.state.setRrAreaDataCategorySLeftSide(rrDataCategorySLeftSide.items, rrDataCategorySLeftSide.title);

    return new CategorySContainer(this.state.getModel());
  }
}
